
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.36 14.3c0-1.3-.27-2.61-1.73-2.94-.78-.16-1.58-.13-2.36-.3l-1.18-.12.05-.58a11.82 11.82 0 00.06-1.88 6.49 6.49 0 00-1.8-3.24c-3.67-3.5-10.66-.73-11.1 4.3l-1.47-.15-.5-.05a1.14 1.14 0 00-.58.11 2.48 2.48 0 00-2.32 2.42c-.33 1.46-.55 2.83-1 4.39l-2.35 11a9.74 9.74 0 00-.45 2.84 4.29 4.29 0 003.81 4.21c3 .35 6 .62 9 1s5.8.71 8.66 1A4.52 4.52 0 0033 33a13.55 13.55 0 00.14-2.77c0-3.88.07-7.65.1-11.42.06-1.54.08-2.93.12-4.51zm-16.17-6a5.55 5.55 0 011.75-2.93c1.82-1.53 4.32-.61 5.89.82a5.7 5.7 0 011.51 3.11 7.6 7.6 0 010 1.43c-.73-.09-1.47-.17-2.17-.23-2.41-.28-4.76-.51-7.08-.76zm14.14 7.6c-.1 3.47 0 7.05-.12 10.52 0 1.49-.05 2.87-.09 4.46a4.9 4.9 0 01-.33 2.65c-.81 1.23-2 1-3.06.93-1.38-.12-2.76-.34-4.14-.46-3.44-.4-7-.71-10.43-1.11l-2.27-.2a2.53 2.53 0 01-2.13-2.87 1 1 0 01.14-.49c.59-3.32 1.36-6.53 2.15-9.85l1.18-5.55c0-.5.23-2.57.92-2.51a.91.91 0 00.4-.14l1.58.18-.26 3c0 .2 1.79-.05 1.84-.64l.19-2.17 9.25 1-.24 2.74c-.11.09 1.79 0 1.85-.73l.16-1.81 1.47.17c.6 0 1.7-.06 2 .67a5.35 5.35 0 01-.06 2.22z","fill":"#06132f"}}),_c('path',{attrs:{"d":"M20.23 27l.67-7.7M24.41 23.45l-7.69-.68","fill":"none","stroke":"#06132f","stroke-linecap":"round","stroke-width":"2"}})])
          )
        }
      }
    